module.exports = __webpack_public_path__ + "img/wales.f8d71ca6.svg";